enum MessengerColor {
  BLUE = 'blue',
  WHITE = 'white',
};

export default MessengerColor;
